var map = {
	"./avatar_tsumego_ai_1-kid.png": 22844,
	"./avatar_tsumego_ai_10-kid.png": 49186,
	"./avatar_tsumego_ai_11-kid.png": 83449,
	"./avatar_tsumego_ai_12-kid.png": 26564,
	"./avatar_tsumego_ai_13-kid.png": 9947,
	"./avatar_tsumego_ai_14-kid.png": 70494,
	"./avatar_tsumego_ai_15-kid.png": 11525,
	"./avatar_tsumego_ai_16-kid.png": 92464,
	"./avatar_tsumego_ai_17-kid.png": 76503,
	"./avatar_tsumego_ai_18-kid.png": 36154,
	"./avatar_tsumego_ai_19-kid.png": 34993,
	"./avatar_tsumego_ai_2-kid.png": 55825,
	"./avatar_tsumego_ai_20-kid.png": 99761,
	"./avatar_tsumego_ai_21-kid.png": 59578,
	"./avatar_tsumego_ai_22-kid.png": 54259,
	"./avatar_tsumego_ai_23-kid.png": 95868,
	"./avatar_tsumego_ai_24-kid.png": 42045,
	"./avatar_tsumego_ai_25-kid.png": 24342,
	"./avatar_tsumego_ai_26-kid.png": 86063,
	"./avatar_tsumego_ai_27-kid.png": 63848,
	"./avatar_tsumego_ai_28-kid.png": 68793,
	"./avatar_tsumego_ai_29-kid.png": 69250,
	"./avatar_tsumego_ai_3-kid.png": 95770,
	"./avatar_tsumego_ai_30-kid.png": 4044,
	"./avatar_tsumego_ai_31-kid.png": 47331,
	"./avatar_tsumego_ai_32-kid.png": 90666,
	"./avatar_tsumego_ai_33-kid.png": 15329,
	"./avatar_tsumego_ai_34-kid.png": 22808,
	"./avatar_tsumego_ai_35-kid.png": 9375,
	"./avatar_tsumego_ai_36-kid.png": 50566,
	"./avatar_tsumego_ai_37-kid.png": 88749,
	"./avatar_tsumego_ai_38-kid.png": 16436,
	"./avatar_tsumego_ai_39-kid.png": 83371,
	"./avatar_tsumego_ai_4-kid.png": 95791,
	"./avatar_tsumego_ai_40-kid.png": 8675,
	"./avatar_tsumego_ai_41-kid.png": 36524,
	"./avatar_tsumego_ai_42-kid.png": 39841,
	"./avatar_tsumego_ai_43-kid.png": 97162,
	"./avatar_tsumego_ai_44-kid.png": 69567,
	"./avatar_tsumego_ai_45-kid.png": 45016,
	"./avatar_tsumego_ai_46-kid.png": 21677,
	"./avatar_tsumego_ai_47-kid.png": 1286,
	"./avatar_tsumego_ai_48-kid.png": 72299,
	"./avatar_tsumego_ai_49-kid.png": 308,
	"./avatar_tsumego_ai_5-kid.png": 65384,
	"./avatar_tsumego_ai_50-kid.png": 60694,
	"./avatar_tsumego_ai_6-kid.png": 82717,
	"./avatar_tsumego_ai_7-kid.png": 47222,
	"./avatar_tsumego_ai_8-kid.png": 58011,
	"./avatar_tsumego_ai_9-kid.png": 30436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5320;